import React, { useState } from 'react';
import { Map } from 'immutable';
import { FleetManagementTable } from '../../fleet-management-table';
import Checkbox from '../../../../frontend-common-libs/src/common/checkbox';
import TCell from '../../../../frontend-common-libs/src/components/common/tables/TCell';
import InstrumentReservation from '../../InstrumentReservation';
import CreateReservationsRow from '../create-reservations-row/CreateReservationsRow';
import styles from './styles/create-reservations-table.module.scss';
import { ImmutableMap, InstrumentItem } from '../../../../frontend-common-libs/src/common/types';

export type Props = {
  instruments: ImmutableMap<InstrumentItem>[];
  reservations: Map<string, InstrumentReservation>;
  updateSelectedInstruments: (id: string, select: boolean) => void;
};

export default function CreateReservationsTable(props: Readonly<Props>) {
  const { instruments, reservations, updateSelectedInstruments } = props;

  const [selectAllCheckbox, setSelectAllCheckbox] = useState<boolean>(false);

  const handleSelectAll = () => {
    setSelectAllCheckbox(!selectAllCheckbox);
  };

  const renderSelectAllCheckbox = () => (
    <TCell>
      <Checkbox
        id="checkbox-select-all"
        name="checkbox-select-all"
        value={selectAllCheckbox}
        checked={selectAllCheckbox}
        onChange={handleSelectAll}
      />
    </TCell>
  );

  const renderAdditionalHeaders = () => <TCell>STATUS</TCell>;

  const renderInstrumentRows = (
    instrumentList: ImmutableMap<InstrumentItem>[]
  ): React.JSX.Element[] => {
    return instrumentList.map((instrument: ImmutableMap<InstrumentItem>) => {
      const instrumentId = instrument.get('id');
      return (
        <CreateReservationsRow
          key={instrumentId}
          instrument={instrument}
          reservation={reservations.get(instrumentId) as InstrumentReservation}
          selectAllCheckbox={selectAllCheckbox}
          updateSelectedInstruments={updateSelectedInstruments}
        />
      );
    });
  };

  const renderTableBody = () => {
    return <tbody>{renderInstrumentRows(instruments)}</tbody>;
  };

  return (
    <div className={styles.createReservationsTable}>
      <FleetManagementTable isHidden={false}>
        {renderSelectAllCheckbox()}
        {renderAdditionalHeaders()}
        {renderTableBody()}
      </FleetManagementTable>
    </div>
  );
}
